import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useContent } from "@/context/ContentContext";

const CtaBand = () => {
  const content = useContent();
  return (
  <section data-testid="cta-band" className="cta-glow relative overflow-hidden py-28 sm:py-32">
    <div className="mx-auto max-w-4xl px-5 text-center sm:px-8">
      <Reveal>
        <h2 className="font-heading text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
          {content.cta_heading || "Let's Build the Future Together."}
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/70 md:text-lg">
          {content.cta_text ||
            "Have a business idea, partnership opportunity or technology requirement? We'd love to hear from you."}
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <Link
          to="/contact"
          data-testid="cta-get-in-touch"
          className="group mt-10 inline-flex items-center gap-2 rounded-full bg-gold px-9 py-4 font-heading text-sm font-bold uppercase tracking-widest text-navy-900 transition-all duration-300 hover:bg-gold-light hover:shadow-xl hover:shadow-gold/25"
        >
          Get in Touch
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  </section>
  );
};

export default CtaBand;
